module.exports = __webpack_public_path__ + "static/img/start.2f6c6fa6.png";